<script setup lang="ts">

import HomeHeader from "@/views/home/HomeHeader.vue";
import HomeFooter from "@/views/home/HomeFooter.vue";
</script>

<template>
  <div id="wrap">

    <home-header />

    <main id="ct">
      <!-- 페이지 시작 -->
      <div class="container support">
        <div class="support-wrap">

          <router-view></router-view>

        </div>
      </div>
      <!-- //container -->
    </main>

    <home-footer />

  </div>
</template>

<style scoped>

</style>